import { Alert, Grid } from '@mui/material';

export const HintsAlert = ({
  hints,
  severity,
  title,
}: {
  hints: string[];
  severity: 'info' | 'warning';
  title: string;
}): JSX.Element | null => {
  if (hints.length === 0) return null;

  return (
    <Grid item xs={12}>
      <Alert severity={severity}>
        <strong>{title}:</strong>
        <ul style={{ margin: 0, paddingLeft: 18 }}>
          {hints.map((hint) => (
            <li key={hint}>{hint}</li>
          ))}
        </ul>
      </Alert>
    </Grid>
  );
};
